<template>
  <div class="common-level-rail">
      <el-radio v-model="radio" label="news">图文素材({{newsCount}})</el-radio>

    <el-button type="primary" class="MpInfoBtn" @click="postMpInfo">下一步</el-button>
  </div>

</template>

<script>
import ArticleApi from "@/api/article.js";
export default {
  components: {},
  data() {
    return {
       radio:'news',
       newsCount:0
    };
  },
  created() {
    /*获取公众号素材统计*/
    this.getTableList();
  },
  methods: {
    /*获取文章列表*/
    getTableList() {
      let self = this;
      let Params = {};
      
      ArticleApi.getMpMaterialCount(Params, true)
        .then((data) => {
          self.loading = false;
          self.newsCount = data.data.count.news_count
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    // 同步公众号文章
    postMpInfo(){
      let self = this;
      let type = this.radio;
      let total = this.newsCount;
      let Params = {};
      Params.type = type
      Params.total = total

      ArticleApi.postMpMaterial(Params, true)
        .then((data) => {
          self.loading = false;
          
          self.$message({
            message: data.msg,
            type: 'success'
          });
        })
        .catch((error) => {
          self.loading = false;
        });
    }
  },
};
</script>

<style>
  .MpInfoBtn{
    display: block;
    margin: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/article/mp/mp.vue